import React from "react";

import { Box } from "@mui/material";

const NotExist: React.FC = () => {
  return (
    <Box fontSize={14} fontWeight="600" color="#7D8797">
      This question no longer exists.
    </Box>
  );
};

export default NotExist;
